export default "__VITE_ASSET__SQB$0I_h__"